import { NgxUiLoaderConfig } from "ngx-ui-loader";

export const LoaderConfig: NgxUiLoaderConfig =
{
    "bgsColor": "#4a2c7a",
    "bgsOpacity": 0.8,
    "bgsPosition": "bottom-right",
    "bgsSize": 90,
    "bgsType": "rectangle-bounce-party",
    "blur": 5,
    "delay": 0,
    "fastFadeOut": true,
    "fgsColor": "#4a2c7a",
    "fgsPosition": "center-center",
    "fgsSize": 150,
    "fgsType": "three-strings",
    "gap": 24,
    "logoPosition": "center-center",
    "logoSize": 150,
    "logoUrl": "../../assets/icons/altarea.png",
    "masterLoaderId": "master",
    "overlayBorderRadius": "0",
    "overlayColor": "rgba(0,0,0,.5)",
    "pbColor": "#4a2c7a",
    "pbDirection": "ltr",
    "pbThickness": 3,
    "hasProgressBar": true,
    "textColor": "#000000",
    "textPosition": "center-center",
    "maxTime": -1,
};